import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyDigitalKyc, fetchDigitalKycData } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { DigiData } from "../Data";
import { Link, Navigate } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";
import { useSearchParams } from "react-router-dom";

const DigitalKyc = () => {
    const [searchParams] = useSearchParams();
const client_id = searchParams.get("client_id");
const status = searchParams.get("status");
    const [isLoading, setIsLoading] = useState(false);
    const [dinData, setDinData] = useState({});
    const [errors, setErrors] = useState({});
    const [profileData, setProfileData] = useState({});
    const [showDinData, setShowDinData] = useState(false)
    const [redirectedURL, setRedirectedURL] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    // const [mobile, setMobile] = useState("")

    const { serviceName } = useService();



    useEffect(() => {
  const fetchDetails = async () => {
    if (!profileData?.user_id || !profileData?.api_key || !profileData?.token_id) return;
    if (!client_id || status !== "success") return;

    try {
      setIsLoading(true);

      const resp = await fetchDigitalKycData({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        client_id
      });

      const statusCode = resp?.status?.code || resp?.status;

      if (statusCode === 200) {
        setDinData(resp?.data || resp.data.data || {});        // here resp.data should be your KYC details
        setShowDinData(true);
        showSuccessToast("KYC details fetched successfully.");
      } else {
        showErrorToast(resp?.data?.message || "Failed to fetch KYC details");
      }
    } catch (e) {
      showErrorToast("Failed to fetch Digilocker Digital KYC details.");
    } finally {
      setIsLoading(false);
    }
  };

  fetchDetails();
}, [profileData, client_id, status]);


    // Fetch profile data on mount
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);


    const validateForm = (redirectedURL, logoUrl) => {
        const errors = {};
        if (!redirectedURL) {
            errors.din = "Redirected URL is required.";
        }
        if (!logoUrl) {
            errors.din = "Logo URL is required.";
        }
        return errors;
    };



   // Digilocker uses OAuth-style redirect flow, and most OAuth providers (including Digilocker) block iframe embedding using X-Frame-Options header to prevent

    const handleSubmit = async () => {
        // const validationErrors = validateForm(redirectedURL, logoUrl);
        // setErrors(validationErrors);
        // if (Object.keys(validationErrors).length > 0) return;

        // if (!mobile) return showErrorToast("Please enter mobile number")

        try {
            setIsLoading(true);

            const response = await verifyDigitalKyc({
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                methodName: 'generateToken',
                redirectedURL: 'https://apiuser.idspay.in/digilocker/digital-kyc',
                logoUrl: 'https://nidhibankingsoftware.in/public/storage/company-file/company.png'
            });

            const statusCode = response?.status?.code || response?.status;


            if (statusCode === 200) {
                const rcData = response?.data;

                if (rcData) {
                    setDinData(rcData);
                    setShowDinData(true);
                    showSuccessToast(response.message, "Token and url Generated successfully.");
                    setRedirectedURL("");
                    setLogoUrl("");
                    setErrors({});

                    if (rcData.url) {
                        window.location.href = rcData.url;   // same tab
                    }


                } else {
                    showErrorToast("Unexpected API format.");
                }
            }



            else if (statusCode === 422) {
                showErrorToast(response.data.message || "Invalid format");
            }

            else if (statusCode === 500) {
                showErrorToast(response.data.message || "Server error");
            }

            else {
                showErrorToast(response.status?.message || "Something went wrong");
            }

        } catch (error) {
            console.error("Digilocker Error:", error);
            showErrorToast("Failed to verify Digilocker Digital Kyc.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>



                <div>
                    <Button
                        type="button"
                        className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                        id="verifyRC"
                        name="verifyRC"
                        text="Verify Aadhar"
                        onClick={handleSubmit}
                    />
                </div>
            </div>

            {/* instructions */}
            {/* <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3 mb-6">
                <h2 class="text-xl font-bold text-center text-gray-800 mb-2">DIN To Contact Verification Steps</h2>

                <ol class="list-decimal list-inside text-gray-700 space-y-1">
                    <li>Enter your 10 digit DIN number.</li>
                    <li>Click on "Verify" to check DIN To Contact details.</li>
                </ol>

                <div class="mt-2">
                    <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
                    <ul class="list-disc list-inside text-gray-600 space-y-1">
                        <li>Do not refresh the page during the verification process.</li>
                        <li>Never share your official document information with anyone.</li>
                        <li>Never share otp related to pan , aadhar to anyone, it can lead to the scams.</li>
                    </ul>
                </div>
            </div> */}

           {showDinData && dinData && (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 px-4 mb-6">
    
    {/* Profile Card */}
    <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-6">
      <h3 className="text-blue-800 font-semibold text-xl mb-4">Profile Details</h3>
      
      {/* Profile Image */}
 {dinData.aadhaar_xml_data?.profile_image && (
  <div className="flex justify-center mb-4">
    <img
      src={`data:image/jpeg;base64,${dinData.aadhaar_xml_data.profile_image.replace(/\s/g, '')}`}
      alt="Profile"
      className="w-32 h-32 rounded-full object-cover border border-gray-300 shadow"
    />
  </div>
)}


      <div className="text-sm text-gray-700 space-y-2">
        <p><strong>Name:</strong> {dinData.aadhaar_xml_data?.full_name}</p>
        <p><strong>Father's Name:</strong> {dinData.aadhaar_xml_data?.father_name}</p>
        <p><strong>Date of Birth:</strong> {dinData.aadhaar_xml_data?.dob}</p>
        <p><strong>Gender:</strong> {dinData.aadhaar_xml_data?.gender === 'M' ? 'Male' : 'Female'}</p>
        <p><strong>Masked Aadhaar:</strong> {dinData.aadhaar_xml_data?.masked_aadhaar}</p>
        <p><strong>Client ID:</strong> {dinData.client_id}</p>
      </div>
    </div>

    {/* Address Card */}
    <div className="bg-gradient-to-br from-green-50 to-white border border-green-200 rounded-2xl shadow-xl p-6">
      <h3 className="text-green-800 font-semibold text-xl mb-4">Address Details</h3>
      <div className="text-sm text-gray-700 space-y-2">
        <p><strong>House:</strong> {dinData.aadhaar_xml_data?.address?.house}</p>
        <p><strong>Street:</strong> {dinData.aadhaar_xml_data?.address?.street}</p>
        <p><strong>Locality:</strong> {dinData.aadhaar_xml_data?.address?.loc}</p>
        <p><strong>Village/Town/City:</strong> {dinData.aadhaar_xml_data?.address?.vtc}</p>
        <p><strong>Sub-District:</strong> {dinData.aadhaar_xml_data?.address?.subdist}</p>
        <p><strong>District:</strong> {dinData.aadhaar_xml_data?.address?.dist}</p>
        <p><strong>State:</strong> {dinData.aadhaar_xml_data?.address?.state}</p>
        <p><strong>Post Office:</strong> {dinData.aadhaar_xml_data?.address?.po}</p>
        <p><strong>PIN Code:</strong> {dinData.aadhaar_xml_data?.zip}</p>
        <p><strong>Country:</strong> {dinData.aadhaar_xml_data?.address?.country}</p>
      </div>
    </div>

    {/* JSON Preview */}
    <div className="bg-gradient-to-br from-purple-50 to-white border border-purple-200 rounded-2xl shadow-xl p-6">
      <h2 className="text-lg font-semibold text-purple-800 mb-3">Raw JSON Data</h2>
      <pre className="bg-gray-100 p-3 rounded text-xs overflow-y-auto max-h-96 whitespace-pre-wrap break-words">
        {JSON.stringify(dinData, null, 2)}
      </pre>
    </div>
  </div>
)}

        </>
    );

    
};

export default DigitalKyc;
